import { createAction, props } from '@ngrx/store';
import { CustomOrderHistory, CustomOrderHistoryFilterAndSortData, CustomOrderHistoryOverview, CustomOrderHistoryRequest, CustomOrderHistoryUpdate } from 'src/app/uig-my-account/custom-order-history/custom-order-history.models';

// *****************************************************

export const getOrderHistoryOverview = createAction(
  '[Custom Order History] get order history overview',
  props<{
    formData: CustomOrderHistoryRequest;
  }>()
);

export const getOrderHistoryOverviewSuccess = createAction(
  '[Custom Order History] get order history overview success',
  props<{ overview: CustomOrderHistoryOverview }>()
);

export const getOrderHistoryOverviewFailure = createAction(
  '[Custom Order History] get order history overview failure',
  props<{ error: Error }>()
);
// *****************************************************

export const sortOrderHistory = createAction(
  '[Custom Order History Filters] sort order history',
  props<{ 
    customOrderHistorySortData: CustomOrderHistoryFilterAndSortData;
  }>()
);

export const backToOrderHistory = createAction(
  '[Custom Order History Filters] back to order history'
);

export const resetBackToOrderHistory = createAction(
  '[Custom Order History Filters] reset back to order history'
);
// *****************************************************

export const clearOrderHistoryOverview = createAction(
  '[Custom Order History] clear order history overview'
);

// *****************************************************

export const getOrderHistory = createAction(
  '[Custom Order History] get order history',
  props<{
    uigOrderNumber: string;
  }>()
);

export const getOrderHistorySuccess = createAction(
  '[Custom Order History] get order history success',
  props<{ order: CustomOrderHistory }>()
);

export const getOrderHistoryFailure = createAction(
  '[Custom Order History] get order history failure',
  props<{ error: Error }>()
);


// *****************************************************

export const cancelOrder = createAction(
  '[Custom Order History] cancel order',
  props<{
    uigOrderNumber: string;
  }>()
);

export const cancelOrderSuccess = createAction(
  '[Custom Order History] cancel order success'
);

export const cancelOrderFailure = createAction(
  '[Custom Order History] cancel order failure'
);
export const cancelOrderReset = createAction(
  '[Custom Order History] cancel order reset'
);

// *****************************************************

export const cancelOrderEntry = createAction(
  '[Custom Order History] cancel order entry',
  props<{
    uigOrderNumber: string;
    position: string;
  }>()
);

export const cancelOrderEntrySuccess = createAction(
  '[Custom Order History] cancel order entry success'
);

export const cancelOrderEntryFailure = createAction(
  '[Custom Order History] cancel order entry failure'
);
export const cancelOrderEntryReset = createAction(
  '[Custom Order History] cancel order entry reset'
);

// *****************************************************

export const updateOrderEntries = createAction(
  '[Custom Order History] update order entries',
  props<{
    formData: CustomOrderHistoryUpdate;
  }>()
);

export const updateOrderEntriesSuccess = createAction(
  '[Custom Order History] update order entries success'
);

export const updateOrderEntriesFailure = createAction(
  '[Custom Order History] update order entries failure'
);
export const updateOrderEntriesReset = createAction(
  '[Custom Order History] update order entries reset'
);
